/* Burga-style client-side filter bar + product grid.
 * Fully independent of Dawn's native facets.js / <facet-filters-form> system.
 * Fetches the full product dataset (with metafields) once via the
 * templates/collection.filter-data.liquid JSON feed, then filters/sorts/paginates
 * entirely in the browser. Vanilla JS, no dependencies. Filters apply immediately on click
 * (no separate "Apply" step) — the Filtern drawer stays open so multiple filters can be
 * combined, and can be closed via the X, the dark overlay, or Escape. */

(function () {
  if (customElements.get('burga-facets')) return;

  // Farbwerte entsprechen exakt den "Color: …"-Tags (englisch) aus dem Produkt-Feed.
  // "Multicolor" fehlt bewusst — dafür rendert swatchStyle() einen Farbverlauf.
  // Die Holzarten stehen hier mit drin, damit auch die Holzarten-Pills Swatches bekommen.
  var COLOR_HEX = {
    'Beige': '#D8C3A5',
    'Black': '#000000',
    'Blue': '#2C5AA0',
    'Brown': '#6B4A2F',
    'Gold': '#C8A951',
    'Green': '#3F7D4E',
    'Pink': '#E29AB8',
    'Purple': '#7B5EA7',
    'Red': '#B02E2E',
    'White': '#FFFFFF',
    'Yellow': '#E8C33A',
    'Bambus': '#D9B879',
    'Nussbaumholz': '#5C4033',
    'Kirschholz': '#8B4A2F',
    'Rosenholz': '#6E3B3B'
  };

  // Reihenfolge der Holzarten im Filter (unbekannte Werte werden alphabetisch angehängt).
  var WOOD_ORDER = ['Bambus', 'Nussbaumholz', 'Kirschholz', 'Rosenholz'];

  // TODO (anderst.com): Reihenfolge der Case-Typen im eigenen Sortiment.
  var CASE_TYP_ORDER = ['Wallet Case', 'Victor Case', 'Panorama Case', 'Regular Case', 'Wood', 'Origami', 'Eden Case'];
  // TODO (anderst.com): Reihenfolge der Motiv-Kategorien im eigenen Sortiment.
  var MOTIV_ORDER = ['City', 'Art', 'Floral & Nature', 'Plain Color', 'FC Basel'];
  var PAGE_SIZE = 24;
  var VISIBLE_PILLS = 8;

  function parsePrice(str) {
    if (!str) return 0;
    var cleaned = String(str).replace(/[^0-9.,]/g, '');
    if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') > -1) {
      cleaned = cleaned.replace(/,/g, '');
    } else if (cleaned.indexOf(',') > -1) {
      cleaned = cleaned.replace(',', '.');
    }
    var n = parseFloat(cleaned);
    return isNaN(n) ? 0 : n;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Liest die vom Snippet eingebettete Modellwechsel-Datenquelle (Menü "modellwechsel").
  function readSwitchData(root) {
    var el = root.querySelector('script[data-role="model-switch-data"]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function swatchStyle(colorName) {
    var hex = COLOR_HEX[colorName];
    if (colorName === 'Multicolor' || colorName === 'Mehrfarbig') {
      return 'background: conic-gradient(red, orange, yellow, green, blue, violet, red);';
    }
    if (!hex) return 'background:#ccc;';
    var border = hex.toUpperCase() === '#FFFFFF' ? 'border:1px solid #ddd;' : '';
    return 'background:' + hex + ';' + border;
  }

  var I18N = {
    de: { loading:'Lädt…',model:'Modell',case_type:'Case-Typ',filter:'Filtern',filter_upper:'FILTERN',sort:'Sortieren',recommended:'Empfohlen',price_asc:'Preis aufsteigend',price_desc:'Preis absteigend',newest:'Neueste',choose_model:'MODELL WÄHLEN',choose_case_type:'CASE-TYP WÄHLEN',close:'Schliessen',search_model:'Modell suchen…',color:'FARBE',wood_types:'HOLZARTEN',design:'MOTIV',magsafe:'MAGSAFE',magsafe_compatible:'MagSafe-kompatibel',clear_all:'Alle Filter löschen',products_loading:'Produkte werden geladen…',show_more:'Mehr anzeigen',show_less:'Weniger anzeigen',all_models:'Alle Modelle',selected:'Ausgewählt',no_models:'Keine Modelle gefunden.',all_case_types:'Alle Case-Typen',no_options:'Keine Optionen verfügbar.',no_designs:'Keine Motive verfügbar.',load_error:'Die Produkte konnten nicht geladen werden. Bitte Seite neu laden.',no_products:'Keine Produkte gefunden. Bitte Filter anpassen.',products:'{count} Produkte',products_filtered:'{count} von {total} Produkten',previous_page:'Vorherige Seite',next_page:'Nächste Seite',remove_filter:'Filter entfernen',universal_group:'Mehrere Modelle / Universal',filters_reset:'Filter zurückgesetzt – für dieses Modell nicht verfügbar' },
    en: { loading:'Loading…',model:'Model',case_type:'Case type',filter:'Filter',filter_upper:'FILTERS',sort:'Sort',recommended:'Recommended',price_asc:'Price: low to high',price_desc:'Price: high to low',newest:'Newest',choose_model:'CHOOSE MODEL',choose_case_type:'CHOOSE CASE TYPE',close:'Close',search_model:'Search model…',color:'COLOR',wood_types:'WOOD TYPES',design:'DESIGN',magsafe:'MAGSAFE',magsafe_compatible:'MagSafe compatible',clear_all:'Clear all filters',products_loading:'Loading products…',show_more:'Show more',show_less:'Show less',all_models:'All models',selected:'Selected',no_models:'No models found.',all_case_types:'All case types',no_options:'No options available.',no_designs:'No designs available.',load_error:'Products could not be loaded. Please reload the page.',no_products:'No products found. Please adjust your filters.',products:'{count} products',products_filtered:'{count} of {total} products',previous_page:'Previous page',next_page:'Next page',remove_filter:'Remove filter',universal_group:'Multiple models / Universal',filters_reset:'Filters reset — not available for this model' },
    fr: { loading:'Chargement…',model:'Modèle',case_type:'Type de coque',filter:'Filtrer',filter_upper:'FILTRES',sort:'Trier',recommended:'Recommandé',price_asc:'Prix croissant',price_desc:'Prix décroissant',newest:'Nouveautés',choose_model:'CHOISIR UN MODÈLE',choose_case_type:'CHOISIR UN TYPE DE COQUE',close:'Fermer',search_model:'Rechercher un modèle…',color:'COULEUR',wood_types:'TYPES DE BOIS',design:'DESIGN',magsafe:'MAGSAFE',magsafe_compatible:'Compatible MagSafe',clear_all:'Effacer tous les filtres',products_loading:'Chargement des produits…',show_more:'Afficher plus',show_less:'Afficher moins',all_models:'Tous les modèles',selected:'Sélectionné',no_models:'Aucun modèle trouvé.',all_case_types:'Tous les types de coque',no_options:'Aucune option disponible.',no_designs:'Aucun design disponible.',load_error:'Impossible de charger les produits. Veuillez actualiser la page.',no_products:'Aucun produit trouvé. Veuillez modifier les filtres.',products:'{count} produits',products_filtered:'{count} produits sur {total}',previous_page:'Page précédente',next_page:'Page suivante',remove_filter:'Supprimer le filtre',universal_group:'Plusieurs modèles / Universel',filters_reset:'Filtres réinitialisés – non disponibles pour ce modèle' },
    it: { loading:'Caricamento…',model:'Modello',case_type:'Tipo di cover',filter:'Filtra',filter_upper:'FILTRI',sort:'Ordina',recommended:'Consigliati',price_asc:'Prezzo crescente',price_desc:'Prezzo decrescente',newest:'Novità',choose_model:'SCEGLI IL MODELLO',choose_case_type:'SCEGLI IL TIPO DI COVER',close:'Chiudi',search_model:'Cerca modello…',color:'COLORE',wood_types:'TIPI DI LEGNO',design:'MOTIVO',magsafe:'MAGSAFE',magsafe_compatible:'Compatibile MagSafe',clear_all:'Cancella tutti i filtri',products_loading:'Caricamento prodotti…',show_more:'Mostra di più',show_less:'Mostra meno',all_models:'Tutti i modelli',selected:'Selezionato',no_models:'Nessun modello trovato.',all_case_types:'Tutti i tipi di cover',no_options:'Nessuna opzione disponibile.',no_designs:'Nessun motivo disponibile.',load_error:'Impossibile caricare i prodotti. Ricarica la pagina.',no_products:'Nessun prodotto trovato. Modifica i filtri.',products:'{count} prodotti',products_filtered:'{count} di {total} prodotti',previous_page:'Pagina precedente',next_page:'Pagina successiva',remove_filter:'Rimuovi filtro',universal_group:'Più modelli / Universale',filters_reset:'Filtri azzerati – non disponibili per questo modello' }
  };

  // Anzeige-Übersetzungen für Filter-WERTE (Farben, Motive, Case-Typen, Holzarten).
  // Die Rohwerte aus dem Feed (englische Tags bzw. deutsche Holzarten) bleiben für
  // Filterlogik, URL-Parameter und Swatches unverändert; nur die Beschriftung wird übersetzt.
  // Unbekannte Werte werden unverändert angezeigt.
  var VALUE_I18N = {
    de: { 'Beige':'Beige','Black':'Schwarz','Blue':'Blau','Brown':'Braun','Gold':'Gold','Green':'Grün','Multicolor':'Mehrfarbig','Pink':'Pink','Purple':'Violett','Red':'Rot','White':'Weiss','Yellow':'Gelb',
          'Art':'Kunst','City':'Stadt','FC Basel':'FC Basel','Floral & Nature':'Blumen & Natur','Plain Color':'Einfarbig',
          'Regular Case':'Standard-Hülle','Victor Case':'Victor Case','Wallet Case':'Wallet Case','Wood':'Holz','Panorama Case':'Panorama Case','Origami':'Origami','Eden Case':'Eden Case',
          'Bambus':'Bambus','Nussbaumholz':'Nussbaumholz','Kirschholz':'Kirschholz','Rosenholz':'Rosenholz' },
    en: { 'Bambus':'Bamboo','Nussbaumholz':'Walnut','Kirschholz':'Cherry','Rosenholz':'Rosewood' },
    fr: { 'Beige':'Beige','Black':'Noir','Blue':'Bleu','Brown':'Marron','Gold':'Or','Green':'Vert','Multicolor':'Multicolore','Pink':'Rose','Purple':'Violet','Red':'Rouge','White':'Blanc','Yellow':'Jaune',
          'Art':'Art','City':'Ville','FC Basel':'FC Basel','Floral & Nature':'Floral & Nature','Plain Color':'Couleur unie',
          'Regular Case':'Coque standard','Victor Case':'Victor Case','Wallet Case':'Wallet Case','Wood':'Bois','Panorama Case':'Panorama Case','Origami':'Origami','Eden Case':'Eden Case',
          'Bambus':'Bambou','Nussbaumholz':'Noyer','Kirschholz':'Cerisier','Rosenholz':'Bois de rose' },
    it: { 'Beige':'Beige','Black':'Nero','Blue':'Blu','Brown':'Marrone','Gold':'Oro','Green':'Verde','Multicolor':'Multicolore','Pink':'Rosa','Purple':'Viola','Red':'Rosso','White':'Bianco','Yellow':'Giallo',
          'Art':'Arte','City':'Città','FC Basel':'FC Basel','Floral & Nature':'Fiori & Natura','Plain Color':'Tinta unita',
          'Regular Case':'Cover standard','Victor Case':'Victor Case','Wallet Case':'Wallet Case','Wood':'Legno','Panorama Case':'Panorama Case','Origami':'Origami','Eden Case':'Eden Case',
          'Bambus':'Bambù','Nussbaumholz':'Noce','Kirschholz':'Ciliegio','Rosenholz':'Legno di rosa' }
  };

  class BurgaFacets extends HTMLElement {
    constructor() {
      super();
    }

    // Übersetzt einen Filter-Wert für die Anzeige (Rohwert bleibt für Logik/URL erhalten).
    tv(value) {
      var map = VALUE_I18N[this.lang] || {};
      return Object.prototype.hasOwnProperty.call(map, value) ? map[value] : value;
    }

    t(key, vars) {
      var value = (I18N[this.lang] && I18N[this.lang][key]) || I18N.de[key] || key;
      Object.keys(vars || {}).forEach(function (name) { value = value.replace('{' + name + '}', vars[name]); });
      return value;
    }

    applyStaticTranslations() {
      var self = this;
      this.querySelectorAll('[data-i18n]').forEach(function (el) { el.textContent = self.t(el.getAttribute('data-i18n')); });
      this.querySelectorAll('[data-i18n-placeholder]').forEach(function (el) { el.setAttribute('placeholder', self.t(el.getAttribute('data-i18n-placeholder'))); });
      this.querySelectorAll('[data-i18n-aria]').forEach(function (el) { el.setAttribute('aria-label', self.t(el.getAttribute('data-i18n-aria'))); });
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.lang = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
      if (!I18N[this.lang]) this.lang = 'de';
      this.applyStaticTranslations();

      this.collectionUrl = this.getAttribute('data-collection-url') || window.location.pathname;
      this.products = [];
      this.totalPages = 1;

      this.state = {
        model: null,
        caseTyp: null,
        farben: [],
        holzarten: [],
        motiv: [],
        magsafe: false,
        sort: 'relevance',
        page: 1
      };
      this.expanded = { motiv: false };
      this.modelSearch = '';
      this._emptyRecoveryDone = false;

      this.readStateFromUrl();

      this.cacheDom();
      this.bindStaticEvents();
      this.loadData();
    }

    cacheDom() {
      this.$count = this.querySelector('[data-role="count"]');
      this.$sortSelect = this.querySelector('[data-role="sort-select"]');
      this.$chips = this.querySelector('[data-role="chips"]');
      this.$grid = this.querySelector('[data-role="grid"]');
      this.$pagination = this.querySelector('[data-role="pagination"]');
      this.$modelList = this.querySelector('[data-role="model-list"]');
      this.$modelSearch = this.querySelector('[data-role="model-search"]');
      this.$caseTypList = this.querySelector('[data-role="case-typ-list"]');
      this.$farbenPills = this.querySelector('[data-role="farben-pills"]');
      this.$holzartenPills = this.querySelector('[data-role="holzarten-pills"]');
      this.$motivPills = this.querySelector('[data-role="motiv-pills"]');
      this.$magsafePill = this.querySelector('[data-stage="magsafe"]');
      this.$overlay = this.querySelector('[data-role="overlay"]');

      this.$modelBtn = this.querySelector('[data-open="model"]');
      this.switchModels = readSwitchData(this);
      this.currentSwitchModel = null;
      for (var i = 0; i < this.switchModels.length; i++) {
        if (this.switchModels[i].current) { this.currentSwitchModel = this.switchModels[i]; break; }
      }
    }

    readStateFromUrl() {
      var params = new URLSearchParams(window.location.search);
      if (params.get('modell')) this.state.model = params.get('modell');
      if (params.get('casetyp')) this.state.caseTyp = params.get('casetyp');
      if (params.get('farbe')) this.state.farben = params.get('farbe').split(',').filter(Boolean);
      if (params.get('holzart')) this.state.holzarten = params.get('holzart').split(',').filter(Boolean);
      if (params.get('motiv')) this.state.motiv = params.get('motiv').split(',').filter(Boolean);
      if (params.get('magsafe') === '1') this.state.magsafe = true;
      if (params.get('sort')) this.state.sort = params.get('sort');
      if (params.get('page')) this.state.page = parseInt(params.get('page'), 10) || 1;
    }

    writeStateToUrl() {
      var params = new URLSearchParams();
      if (this.state.model) params.set('modell', this.state.model);
      if (this.state.caseTyp) params.set('casetyp', this.state.caseTyp);
      if (this.state.farben.length) params.set('farbe', this.state.farben.join(','));
      if (this.state.holzarten.length) params.set('holzart', this.state.holzarten.join(','));
      if (this.state.motiv.length) params.set('motiv', this.state.motiv.join(','));
      if (this.state.magsafe) params.set('magsafe', '1');
      if (this.state.sort && this.state.sort !== 'relevance') params.set('sort', this.state.sort);
      if (this.state.page && this.state.page > 1) params.set('page', String(this.state.page));
      var qs = params.toString();
      var newUrl = window.location.pathname + (qs ? '?' + qs : '');
      window.history.replaceState(null, '', newUrl);
    }

    bindStaticEvents() {
      var self = this;

      this.querySelectorAll('[data-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.openPanel(btn.getAttribute('data-open'));
        });
      });

      this.querySelectorAll('[data-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.closePanel(btn.getAttribute('data-close'));
        });
      });

      this.$overlay.addEventListener('click', function () {
        self.closeAllPanels();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.closeAllPanels();
      });

      if (this.$modelSearch) {
        this.$modelSearch.addEventListener('input', function () {
          self.modelSearch = self.$modelSearch.value.trim().toLowerCase();
          self.renderModelList();
        });
      }

      if (this.$sortSelect) {
        this.$sortSelect.value = this.state.sort;
        this.$sortSelect.addEventListener('change', function () {
          self.state.sort = self.$sortSelect.value;
          self.state.page = 1;
          self.filterAndRender();
        });
      }

      var clearAllBtn = this.querySelector('[data-role="clear-all"]');
      if (clearAllBtn) {
        clearAllBtn.addEventListener('click', function () {
          self.state.model = null;
          self.state.caseTyp = null;
          self.state.farben = [];
          self.state.holzarten = [];
          self.state.motiv = [];
          self.state.magsafe = false;
          self.state.page = 1;
          self.renderModelList();
          self.renderCaseTypList();
          self.renderFarbenPills();
          self.renderHolzartenPills();
          self.renderMotivPills();
          self.renderMagsafePill();
          self.filterAndRender();
        });
      }

      this.querySelectorAll('[data-more]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.getAttribute('data-more');
          self.expanded[group] = !self.expanded[group];
          btn.textContent = self.expanded[group] ? self.t('show_less') : self.t('show_more');
          if (group === 'motiv') self.renderMotivPills();
        });
      });

      if (this.$magsafePill) {
        this.$magsafePill.addEventListener('click', function () {
          self.state.magsafe = !self.state.magsafe;
          self.state.page = 1;
          self.renderMagsafePill();
          self.filterAndRender();
        });
      }

      this.$pagination.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-page]');
        if (!btn || btn.disabled) return;
        self.state.page = parseInt(btn.getAttribute('data-page'), 10);
        self.renderGrid();
        self.renderPagination();
        self.writeStateToUrl();
        self.scrollToTop();
      });

      this.$chips.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-chip-remove]');
        if (!btn) return;
        var type = btn.getAttribute('data-chip-remove');
        var value = btn.getAttribute('data-chip-value');
        self.removeFilter(type, value);
      });
    }

    removeFilter(type, value) {
      if (type === 'model') this.state.model = null;
      else if (type === 'caseTyp') this.state.caseTyp = null;
      else if (type === 'farben') {
        this.state.farben = this.state.farben.filter(function (v) { return v !== value; });
      } else if (type === 'holzarten') {
        this.state.holzarten = this.state.holzarten.filter(function (v) { return v !== value; });
      } else if (type === 'motiv') {
        this.state.motiv = this.state.motiv.filter(function (v) { return v !== value; });
      } else if (type === 'magsafe') {
        this.state.magsafe = false;
      }
      this.state.page = 1;
      this.renderModelList();
      this.renderCaseTypList();
      this.renderFarbenPills();
      this.renderHolzartenPills();
      this.renderMotivPills();
      this.renderMagsafePill();
      this.filterAndRender();
    }

    openPanel(name) {
      var selector = name === 'case-typ' ? '[data-modal="case-typ"]' : '[data-drawer="' + name + '"]';
      var el = this.querySelector(selector);
      if (!el) return;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      this.classList.add('has-open');
    }

    closePanel(name) {
      var selector = name === 'case-typ' ? '[data-modal="case-typ"]' : '[data-drawer="' + name + '"]';
      var el = this.querySelector(selector);
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      if (!this.querySelector('.is-open')) this.classList.remove('has-open');
    }

    closeAllPanels() {
      this.querySelectorAll('.burga-drawer.is-open, .burga-modal.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        el.setAttribute('aria-hidden', 'true');
      });
      this.classList.remove('has-open');
    }

    scrollToTop() {
      var rect = this.getBoundingClientRect();
      if (rect.top < 0) window.scrollTo({ top: window.scrollY + rect.top - 20, behavior: 'smooth' });
    }

    fetchPage(n) {
      // Note: deliberately no Accept: application/json header here — Shopify's storefront
      // routing intercepts that header and serves its built-in generic collection JSON API
      // response instead of our custom `?view=filter-data` alternate Liquid template.
      var url = this.collectionUrl + '?view=filter-data&page=' + n;
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    }

    loadData() {
      var self = this;
      this.$count.textContent = this.t('loading');
      return this.fetchPage(1)
        .then(function (first) {
          var all = (first.products || []).slice();
          var pages = first.pages || 1;
          self.totalPages = pages;
          if (pages > 1) {
            var rest = [];
            for (var i = 2; i <= pages; i++) rest.push(self.fetchPage(i));
            return Promise.all(rest).then(function (results) {
              results.forEach(function (r) {
                all = all.concat(r.products || []);
              });
              return all;
            });
          }
          return all;
        })
        .then(function (all) {
          self.products = all;
          self.buildFacetOptions();
          self.renderModelList();
          self.renderCaseTypList();
          self.renderFarbenPills();
          self.renderHolzartenPills();
          self.renderMotivPills();
          self.renderMagsafePill();
          self.filterAndRender();
          self.recoverEmptyResult();
        })
        .catch(function (err) {
          console.error('BurgaFacets: failed to load product feed', err);
          self.$grid.innerHTML = '<div class="burga-empty">' + self.t('load_error') + '</div>';
          self.$count.textContent = '';
        });
    }

    buildFacetOptions() {
      var farben = {};
      var holzarten = {};
      this.products.forEach(function (p) {
        (p.farben || []).forEach(function (f) { if (f) farben[f] = true; });
        if (p.holzart) holzarten[p.holzart] = true;
      });

      var self = this;
      this.colorOptions = Object.keys(farben).sort(function (a, b) { return self.tv(a).localeCompare(self.tv(b), self.lang); });

      // Feste Reihenfolge laut WOOD_ORDER, unerwartete Werte alphabetisch dahinter.
      var known = WOOD_ORDER.filter(function (w) { return holzarten[w]; });
      var extra = Object.keys(holzarten).filter(function (w) { return WOOD_ORDER.indexOf(w) === -1; })
        .sort(function (a, b) { return a.localeCompare(b, 'de'); });
      this.woodOptions = known.concat(extra);
    }

    // Baut die Ziel-URL für einen Modellwechsel. targetUrl kommt locale-aware aus dem Menü
    // und wird nicht angefasst; "modell" und "page" werden bewusst NICHT mitgenommen.
    buildSwitchUrl(targetUrl) {
      var params = new URLSearchParams();
      if (this.state.caseTyp) params.set('casetyp', this.state.caseTyp);
      if (this.state.farben && this.state.farben.length) params.set('farbe', this.state.farben.join(','));
      if (this.state.holzarten && this.state.holzarten.length) params.set('holzart', this.state.holzarten.join(','));
      if (this.state.motiv && this.state.motiv.length) params.set('motiv', this.state.motiv.join(','));
      if (this.state.magsafe) params.set('magsafe', '1');
      if (this.state.sort && this.state.sort !== 'relevance') params.set('sort', this.state.sort);
      var qs = params.toString();
      return targetUrl + (qs ? '?' + qs : '');
    }

    // Der Modell-Drawer filtert nicht mehr innerhalb der Collection, sondern navigiert auf die
    // Collection des gewählten Modells. Datenquelle ist das Menü "modellwechsel".
    renderModelList() {
      var self = this;
      var entries = this.switchModels || [];

      if (!entries.length) {
        // Menü fehlt oder ist leer: Modell-Button ausblenden, Drawer bleibt leer.
        this.setModelBtnVisible(false);
        this.$modelList.innerHTML = '<div class="burga-empty">' + this.t('no_models') + '</div>';
        return;
      }
      this.setModelBtnVisible(true);

      var order = [];
      var byGroup = {};
      entries.forEach(function (entry) {
        var title = String(entry.title == null ? '' : entry.title);
        if (self.modelSearch && title.toLowerCase().indexOf(self.modelSearch) === -1) return;
        var group = String(entry.group == null ? '' : entry.group);
        if (order.indexOf(group) === -1) { order.push(group); byGroup[group] = []; }
        byGroup[group].push(entry);
      });

      var html = '';
      order.forEach(function (group) {
        html += '<div class="burga-model-group"><h5>' + escapeHtml(group) + '</h5>';
        byGroup[group].forEach(function (entry) {
          var inner = escapeHtml(entry.title) +
            '<span class="burga-model-row__count">' + escapeHtml(entry.count) + '</span>' +
            '<span class="burga-model-row__check">✓ ' + self.t('selected') + '</span>';
          if (entry.current) {
            html += '<div class="burga-model-row is-selected" aria-current="true">' + inner + '</div>';
          } else {
            html += '<a class="burga-model-row" data-switch-url="' + escapeHtml(entry.url) + '" href="' + escapeHtml(self.buildSwitchUrl(entry.url)) + '">' + inner + '</a>';
          }
        });
        html += '</div>';
      });

      if (!html) html = '<div class="burga-empty">' + this.t('no_models') + '</div>';
      this.$modelList.innerHTML = html;

      // Aktuelles Modell im Pill-Button spiegeln (läuft nach applyStaticTranslations()).
      var label = this.$modelBtn && this.$modelBtn.querySelector('[data-i18n="model"]');
      if (label && this.currentSwitchModel) {
        label.removeAttribute('data-i18n');
        label.textContent = this.currentSwitchModel.title;
      }
    }

    // Die Modellwechsel-Links werden einmal gerendert, die aktiven Filter ändern sich aber
    // danach noch. Deshalb nach jedem Filterwechsel nur die hrefs nachziehen (kein Re-Render,
    // damit die Scroll-Position im Drawer erhalten bleibt).
    updateSwitchUrls() {
      var self = this;
      if (!this.$modelList) return;
      this.$modelList.querySelectorAll('a.burga-model-row[data-switch-url]').forEach(function (a) {
        a.setAttribute('href', self.buildSwitchUrl(a.getAttribute('data-switch-url')));
      });
    }

    // .burga-pillbtn setzt display:inline-flex und überschreibt damit das [hidden]-Default des
    // Browsers — deshalb zusätzlich zu hidden auch style.display setzen.
    setModelBtnVisible(visible) {
      if (!this.$modelBtn) return;
      this.$modelBtn.hidden = !visible;
      this.$modelBtn.style.display = visible ? '' : 'none';
    }

    renderCaseTypList() {
      var self = this;
      var present = {};
      this.products.forEach(function (p) {
        (p.case_types || (p.case_typ ? [p.case_typ] : [])).forEach(function (type) {
          if (type) present[type] = true;
        });
      });
      var types = CASE_TYP_ORDER.filter(function (t) { return present[t]; });
      Object.keys(present).sort(function (a, b) { return a.localeCompare(b, 'de'); }).forEach(function (t) { if (types.indexOf(t) === -1) types.push(t); });

      var html = '<div class="burga-casetyp-grid">';
      html += '<button type="button" class="burga-casetyp-card burga-casetyp-card--all' + (!this.state.caseTyp ? ' is-selected' : '') + '" data-casetyp-value="">' + this.t('all_case_types') + '</button>';
      types.forEach(function (t) {
        var selected = self.state.caseTyp === t;
        html += '<button type="button" class="burga-casetyp-card' + (selected ? ' is-selected' : '') + '" data-casetyp-value="' + escapeHtml(t) + '">' +
          '<span class="burga-casetyp-icon">▢</span><span class="burga-casetyp-card__label">' + escapeHtml(self.tv(t)) + '</span></button>';
      });
      html += '</div>';
      this.$caseTypList.innerHTML = html;

      this.$caseTypList.querySelectorAll('[data-casetyp-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-casetyp-value');
          self.state.caseTyp = val || null;
          self.state.page = 1;
          self.renderCaseTypList();
          self.closePanel('case-typ');
          self.filterAndRender();
        });
      });
    }

    // stage ist der Name des State-Arrays ('farben' oder 'holzarten').
    renderPillGroup($container, options, stage) {
      var self = this;
      var selectedArr = this.state[stage] || [];
      var html = '';
      options.forEach(function (value) {
        var selected = selectedArr.indexOf(value) > -1;
        html += '<button type="button" class="burga-pill' + (selected ? ' is-selected' : '') + '" data-stage="' + stage + '" data-value="' + escapeHtml(value) + '">' +
          '<span class="burga-pill__dot" style="' + swatchStyle(value) + '"></span>' + escapeHtml(self.tv(value)) + '</button>';
      });
      $container.innerHTML = html || '<div class="burga-empty">' + this.t('no_options') + '</div>';

      $container.querySelectorAll('[data-stage="' + stage + '"]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var val = pill.getAttribute('data-value');
          var arr = self.state[stage];
          var idx = arr.indexOf(val);
          if (idx > -1) arr.splice(idx, 1);
          else arr.push(val);
          self.state.page = 1;
          pill.classList.toggle('is-selected');
          self.filterAndRender();
        });
      });
    }

    renderFarbenPills() {
      // Alle Farben werden direkt angezeigt (kein "Mehr anzeigen" mehr nötig).
      this.renderPillGroup(this.$farbenPills, this.colorOptions || [], 'farben');
    }

    renderHolzartenPills() {
      this.renderPillGroup(this.$holzartenPills, this.woodOptions || [], 'holzarten');
    }

    renderMotivPills() {
      var self = this;
      var present = {};
      this.products.forEach(function (p) { if (p.motiv) present[p.motiv] = true; });
      var options = MOTIV_ORDER.filter(function (m) { return present[m]; });
      Object.keys(present).sort(function (a, b) { return a.localeCompare(b, 'de'); }).forEach(function (m) { if (options.indexOf(m) === -1) options.push(m); });
      var visible = this.expanded.motiv ? options : options.slice(0, VISIBLE_PILLS);
      var html = '';
      visible.forEach(function (motiv) {
        var selected = self.state.motiv.indexOf(motiv) > -1;
        html += '<button type="button" class="burga-pill' + (selected ? ' is-selected' : '') + '" data-stage="motiv" data-value="' + escapeHtml(motiv) + '">' + escapeHtml(self.tv(motiv)) + '</button>';
      });
      this.$motivPills.innerHTML = html || '<div class="burga-empty">' + this.t('no_designs') + '</div>';

      var moreBtn = this.querySelector('[data-more="motiv"]');
      if (moreBtn) {
        moreBtn.hidden = options.length <= VISIBLE_PILLS;
        moreBtn.textContent = this.expanded.motiv ? this.t('show_less') : this.t('show_more');
      }

      this.$motivPills.querySelectorAll('[data-stage="motiv"]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var val = pill.getAttribute('data-value');
          var idx = self.state.motiv.indexOf(val);
          if (idx > -1) self.state.motiv.splice(idx, 1);
          else self.state.motiv.push(val);
          self.state.page = 1;
          pill.classList.toggle('is-selected');
          self.filterAndRender();
        });
      });
    }

    renderMagsafePill() {
      if (!this.$magsafePill) return;
      this.$magsafePill.classList.toggle('is-selected', !!this.state.magsafe);
    }

    filterAndRender() {
      var self = this;
      var filtered = this.products.filter(function (p) {
        if (self.state.model && (p.models || (p.handymodell ? [p.handymodell] : [])).indexOf(self.state.model) === -1) return false;
        if (self.state.caseTyp) {
          var caseTypes = p.case_types || (p.case_typ ? [p.case_typ] : []);
          if (caseTypes.indexOf(self.state.caseTyp) === -1) return false;
        }
        if (self.state.farben.length) {
          var has = (p.farben || []).some(function (f) { return self.state.farben.indexOf(f) > -1; });
          if (!has) return false;
        }
        if (self.state.holzarten.length && self.state.holzarten.indexOf(p.holzart) === -1) return false;
        if (self.state.motiv.length && self.state.motiv.indexOf(p.motiv) === -1) return false;
        if (self.state.magsafe && !p.magsafe) return false;
        return true;
      });

      if (this.state.sort === 'price-asc') {
        filtered = filtered.slice().sort(function (a, b) { return parsePrice(a.price) - parsePrice(b.price); });
      } else if (this.state.sort === 'price-desc') {
        filtered = filtered.slice().sort(function (a, b) { return parsePrice(b.price) - parsePrice(a.price); });
      } else if (this.state.sort === 'newest') {
        filtered = filtered.slice().sort(function (a, b) { return b.id - a.id; });
      }

      this.filtered = filtered;
      var pages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
      if (this.state.page > pages) this.state.page = pages;
      if (this.state.page < 1) this.state.page = 1;

      this.renderCount();
      this.renderGrid();
      this.renderPagination();
      this.renderChips();
      this.updateSwitchUrls();
      this.writeStateToUrl();
    }

    // Nach einem Modellwechsel werden die Filter mitgenommen. Trifft davon beim ersten Rendern
    // nichts zu, würde der Shopper auf einem leeren Grid mit Chips landen, die er nie gesetzt hat.
    // Deshalb: Facetten einmalig zurücksetzen und darauf hinweisen. Läuft nur beim Initial-Load,
    // nie wenn der Shopper selbst auf 0 Treffer filtert.
    recoverEmptyResult() {
      if (this._emptyRecoveryDone) return;
      this._emptyRecoveryDone = true;

      var hasFacets = !!this.state.caseTyp || this.state.farben.length > 0 ||
        this.state.holzarten.length > 0 || this.state.motiv.length > 0 || !!this.state.magsafe;
      if (!hasFacets) return;
      if (!this.filtered || this.filtered.length > 0) return;

      this.state.caseTyp = null;
      this.state.farben = [];
      this.state.holzarten = [];
      this.state.motiv = [];
      this.state.magsafe = false;
      this.state.page = 1;

      this.renderCaseTypList();
      this.renderFarbenPills();
      this.renderHolzartenPills();
      this.renderMotivPills();
      this.renderMagsafePill();
      this.filterAndRender(); // schreibt auch die bereinigte URL via writeStateToUrl()

      if (this.$chips) {
        this.$chips.insertAdjacentHTML('beforeend', '<div class="burga-notice">' + this.t('filters_reset') + '</div>');
      }
    }

    renderCount() {
      var total = this.filtered.length;
      var totalAll = this.products.length;
      if (total === totalAll) {
        this.$count.textContent = this.t('products', { count: total });
      } else {
        this.$count.textContent = this.t('products_filtered', { count: total, total: totalAll });
      }
    }

    renderGrid() {
      var self = this;
      var start = (this.state.page - 1) * PAGE_SIZE;
      var pageItems = this.filtered.slice(start, start + PAGE_SIZE);

      if (!pageItems.length) {
        this.$grid.innerHTML = '<div class="burga-empty">' + this.t('no_products') + '</div>';
        return;
      }

      var html = '';
      pageItems.forEach(function (p) {
        html += '<a class="burga-card" href="' + escapeHtml(p.url + (self.state.model && p.model_variants && p.model_variants[self.state.model] ? '?variant=' + p.model_variants[self.state.model] : '')) + '">' +
          '<div class="burga-card__media' + (p.image2 ? ' burga-card__media--has-hover' : '') + '">' +
          (p.image ? '<img class="burga-card__img burga-card__img--front" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="400" height="400">' : '') +
          (p.image2 ? '<img class="burga-card__img burga-card__img--hover" src="' + escapeHtml(p.image2) + '" alt="" loading="lazy" width="400" height="400">' : '') +
          '</div>' +
          '<h3 class="burga-card__title">' + escapeHtml(p.title) + '</h3>' +
          '<div class="burga-card__price">' + escapeHtml(p.price) + '</div>' +
          '</a>';
      });
      this.$grid.innerHTML = html;
    }

    renderPagination() {
      var pages = Math.max(1, Math.ceil(this.filtered.length / PAGE_SIZE));
      var current = this.state.page;
      if (pages <= 1) {
        this.$pagination.innerHTML = '';
        return;
      }

      var html = '';
      html += '<button type="button" data-page="' + (current - 1) + '"' + (current <= 1 ? ' disabled' : '') + ' aria-label="' + this.t('previous_page') + '">‹</button>';

      var pageNums = [];
      for (var i = 1; i <= pages; i++) {
        if (i === 1 || i === pages || Math.abs(i - current) <= 1) pageNums.push(i);
      }
      var last = 0;
      pageNums.forEach(function (n) {
        if (last && n - last > 1) html += '<span>…</span>';
        html += '<button type="button" data-page="' + n + '" class="' + (n === current ? 'is-current' : '') + '">' + n + '</button>';
        last = n;
      });

      html += '<button type="button" data-page="' + (current + 1) + '"' + (current >= pages ? ' disabled' : '') + ' aria-label="' + this.t('next_page') + '">›</button>';
      this.$pagination.innerHTML = html;
    }

    renderChips() {
      var self = this;
      var chips = [];
      if (this.state.model) chips.push({ type: 'model', label: this.state.model });
      if (this.state.caseTyp) chips.push({ type: 'caseTyp', label: this.tv(this.state.caseTyp) });
      this.state.farben.forEach(function (f) { chips.push({ type: 'farben', label: self.tv(f), value: f }); });
      this.state.holzarten.forEach(function (h) { chips.push({ type: 'holzarten', label: self.tv(h), value: h }); });
      this.state.motiv.forEach(function (m) { chips.push({ type: 'motiv', label: self.tv(m), value: m }); });
      if (this.state.magsafe) chips.push({ type: 'magsafe', label: this.t('magsafe_compatible') });

      if (!chips.length) {
        this.$chips.innerHTML = '';
        return;
      }

      var html = '';
      chips.forEach(function (c) {
        html += '<span class="burga-chip">' + escapeHtml(c.label) +
          '<button type="button" data-chip-remove="' + c.type + '"' + (c.value ? ' data-chip-value="' + escapeHtml(c.value) + '"' : '') + ' aria-label="' + self.t('remove_filter') + '">&times;</button></span>';
      });
      this.$chips.innerHTML = html;
    }
  }

  customElements.define('burga-facets', BurgaFacets);
})();